(function () {
  const RECOMMENDATIONS_URL = '/recommendations/products.json';
  const RECOMMENDATIONS_LIMIT = 10;
  const RECOMMENDATIONS_DISPLAY = 3;

  function parseHandleSkipper(str) {
    if (!str || typeof str !== 'string') return [];
    return str
      .split(',')
      .map(function (h) {
        return h.trim().toLowerCase();
      })
      .filter(Boolean);
  }

  function formatMoney(cents) {
    if (typeof cents !== 'number') return '';
    return '$' + (cents / 100).toFixed(2);
  }

  function getProductImageUrl(product) {
    var url = '';
    var feat = product.featured_image;
    if (typeof feat === 'string' && feat) {
      url = feat;
    } else if (feat && feat.src) {
      url = feat.src;
    } else if (product.images && product.images.length > 0) {
      url = typeof product.images[0] === 'string' ? product.images[0] : (product.images[0].src || '');
    } else if (product.media && product.media.length > 0) {
      var m = product.media[0];
      url = (m.src || (m.preview_image && m.preview_image.src)) || '';
    }
    if (url && url.indexOf('//') === 0) {
      url = 'https:' + url;
    }
    return url;
  }

  function escapeHtml(str) {
    if (!str) return '';
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function renderRecommendations(container, products, firstChecked) {
    var skipHandles = parseHandleSkipper(container.dataset.handleSkipper || '');
    var list = products.filter(function (p) {
      return skipHandles.indexOf((p.handle || '').toLowerCase()) === -1;
    });
    list = list.slice(0, RECOMMENDATIONS_DISPLAY);

    var html = '';
    list.forEach(function (product, index) {
      var variant = product.variants && product.variants[0];
      if (!variant) return;
      var imgUrl = getProductImageUrl(product);
      var checked = firstChecked && index === 0 ? ' checked' : '';
      var priceFormatted = product.price != null ? formatMoney(product.price) : '';
      var cbId = 'upsells-rec-cb-' + variant.id;
      var productUrl = (product.url || '').indexOf('http') === 0 ? product.url : (window.shopUrl || '') + (product.url || '');
      var titleEscaped = escapeHtml(product.title || '');
      html +=
        '<div class="upsells-rec-card" data-variant-id="' +
        variant.id +
        '">' +
        '<div class="upsells-rec-checkbox-wrap">' +
        '<input type="checkbox" class="upsells-rec-checkbox" id="' +
        cbId +
        '" name="upsells-rec" value="' +
        variant.id +
        '"' +
        checked +
        ' aria-label="Select ' +
        titleEscaped +
        '"></div>' +
        (imgUrl
          ? '<label class="upsells-rec-image-label" for="' +
            cbId +
            '"><img class="upsells-rec-image" src="' +
            escapeHtml(imgUrl) +
            '" alt="" width="60" height="60" loading="lazy"></label>'
          : '') +
        (productUrl
          ? '<a class="upsells-rec-title" href="' + escapeHtml(productUrl) + '">' + titleEscaped + '</a>'
          : '<span class="upsells-rec-title">' + titleEscaped + '</span>') +
        '<span class="upsells-rec-price">' + priceFormatted + '</span>' +
        '</div>';
    });
    container.innerHTML = html;
  }

  function loadRecommendations(block) {
    var productId = block.dataset.productId;
    var container = block.querySelector('.upsells-recommendations-inner');
    if (!productId || !container) return;

    var root = window.shopUrl || window.Shopify?.routes?.root || '';
    var url = root + RECOMMENDATIONS_URL + '?product_id=' + encodeURIComponent(productId) + '&limit=' + RECOMMENDATIONS_LIMIT;

    container.classList.add('upsells-recommendations-loading');
    container.innerHTML = '';

    fetch(url)
      .then(function (res) {
        return res.json();
      })
      .then(function (data) {
        container.classList.remove('upsells-recommendations-loading');
        var products = data.products || [];
        renderRecommendations(container, products, true);
        // Update button state after recommendations are rendered
        updateButtonState(block);
        // Add event listeners to recommendation checkboxes
        setupCheckboxListeners(block);
      })
      .catch(function () {
        container.classList.remove('upsells-recommendations-loading');
      });
  }

  function getMainVariantAndQuantity(productFormId) {
    var form = document.getElementById(productFormId);
    if (!form) return { variantId: null, quantity: 1 };
    var idInput = form.querySelector('input[name="id"]');
    var qtyInput = form.querySelector('input[name="quantity"]');
    var variantId = idInput ? parseInt(idInput.value, 10) : null;
    if (variantId && isNaN(variantId)) variantId = null;
    var quantity = 1;
    if (qtyInput && qtyInput.value) {
      var n = parseInt(qtyInput.value, 10);
      if (!isNaN(n) && n > 0) quantity = n;
    }
    return { variantId: variantId, quantity: quantity };
  }

  function collectSelectedIds(block) {
    var recIds = [];
    block.querySelectorAll('.upsells-rec-checkbox:checked').forEach(function (cb) {
      if (cb.value) {
        var id = parseInt(cb.value, 10);
        if (!isNaN(id)) recIds.push(id);
      }
    });
    var addonIds = [];
    block.querySelectorAll('.upsells-addon-checkbox:checked').forEach(function (cb) {
      var id = cb.getAttribute('data-variant-id');
      if (id) {
        id = parseInt(id, 10);
        if (!isNaN(id)) addonIds.push(id);
      }
    });
    return { rec: recIds, addon: addonIds };
  }

  function updateButtonState(block) {
    var btn = block.querySelector('.upsells-add-to-cart-btn');
    if (!btn) return;
    
    var selected = collectSelectedIds(block);
    var hasSelection = selected.rec.length > 0 || selected.addon.length > 0;
    
    btn.disabled = !hasSelection;
  }

  function addToCart(block, redirectToCart) {
    var selected = collectSelectedIds(block);
    var items = [];
    
    selected.rec.forEach(function (id) {
      items.push({ id: id, quantity: 1 });
    });
    selected.addon.forEach(function (id) {
      items.push({ id: id, quantity: 1 });
    });

    // Don't proceed if no items selected
    if (items.length === 0) return;

    var btn = block.querySelector('.upsells-add-to-cart-btn');
    if (btn) {
      btn.disabled = true;
      if (btn.querySelector('.loading__spinner')) btn.querySelector('.loading__spinner').classList.remove('hidden');
    }

    var url = (window.routes && window.routes.cart_add_url) || '/cart/add.js';
    var config = typeof fetchConfig === 'function' ? fetchConfig('json') : { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' } };
    config.headers = config.headers || {};
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    config.body = JSON.stringify({ items: items });

    fetch(url, config)
      .then(function (res) {
        return res.json();
      })
      .then(function (data) {
        if (data.status && data.message) {
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartError, { source: 'upsells-addons', errors: data.message || data.description });
          }
          return;
        }
        if (redirectToCart && window.routes && window.routes.cart_url) {
          window.location.href = window.routes.cart_url;
          return;
        }
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'upsells-addons', cartData: data });
        }
        var cartDrawer = document.querySelector('cart-drawer');
        var cartNotification = document.querySelector('cart-notification');
        if (cartDrawer) {
          var cartUrl = (window.routes && window.routes.cart_url) || '/cart';
          fetch(cartUrl + '?section_id=cart-drawer')
            .then(function (r) {
              return r.text();
            })
            .then(function (htmlText) {
              var html = new DOMParser().parseFromString(htmlText, 'text/html');
              ['cart-drawer-items', '.cart-drawer__footer'].forEach(function (sel) {
                var target = document.querySelector(sel);
                var source = html.querySelector(sel);
                if (target && source) target.replaceWith(source);
              });
              cartDrawer.classList.remove('is-empty');
              cartDrawer.open();
            })
            .catch(function () {
              cartDrawer.open();
            });
        } else if (cartNotification) {
          cartNotification.open();
        }
      })
      .catch(function (err) {
        if (err && (err.message || err.description)) {
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartError, { source: 'upsells-addons', errors: err.description || err.message });
          }
        }
      })
      .finally(function () {
        if (btn) {
          if (btn.querySelector('.loading__spinner')) btn.querySelector('.loading__spinner').classList.add('hidden');
        }
        // Update button state based on current selection
        updateButtonState(block);
      });
  }

  function setupCheckboxListeners(block) {
    // Listen for recommendation checkbox changes
    block.querySelectorAll('.upsells-rec-checkbox').forEach(function (checkbox) {
      checkbox.addEventListener('change', function () {
        updateButtonState(block);
      });
    });
    
    // Listen for addon checkbox changes
    block.querySelectorAll('.upsells-addon-checkbox').forEach(function (checkbox) {
      checkbox.addEventListener('change', function () {
        updateButtonState(block);
      });
    });
  }

  function init() {
    document.querySelectorAll('.product-upsells-addons-block').forEach(function (block) {
      loadRecommendations(block);

      // Set up listeners for existing addon checkboxes (if any)
      setupCheckboxListeners(block);
      
      // Initial button state check
      updateButtonState(block);

      var btn = block.querySelector('.upsells-add-to-cart-btn');
      var redirectToCart = block.dataset.redirectToCart === '1';
      if (btn) {
        btn.addEventListener('click', function (evt) {
          evt.preventDefault();
          evt.stopPropagation();
          var targetBlock = evt.currentTarget.closest('.product-upsells-addons-block');
          if (targetBlock) {
            addToCart(targetBlock, redirectToCart);
          }
        });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
